import api from './api';

const service = {
  fetch: params => api.get('audits', params),
};

export default service;
